import { Entity, System } from "ecsy";
import { GainInterest, GainMoney, Health, Ownership, SetHealthEqualMoney, SpendMoney } from "../components";
import { getEntityPlayer } from "../composition";
import { Game } from "../game";
import { Player } from "../player";

export class UnspentMoneySystem extends System {

	game: Game;

	constructor(world: any, attributes: any) {
		// @ts-ignore
		super(world, attributes);
		this.game = attributes.game;
	}

	execute(delta: number, time: number) {

		for (const entity of this.queries.convertToHealth.results) {
			const player = getEntityPlayer(entity, this.game);
			if (!player) continue;

			const converter = entity.getComponent(SetHealthEqualMoney);
			const health = entity.getMutableComponent(Health);
			health.hp = Math.max(1, player.currentFunds * converter.convertionRate);
		}

		const removeGainMoney = new Array<Entity>();
		for (const entity of this.queries.gainMoney.results) {
			const player = getEntityPlayer(entity, this.game);
			if (!player) continue;

			const gain = entity.getComponent(GainMoney);
			this.giveMoney(player, gain.amount);

			removeGainMoney.push(entity);
		}
		removeGainMoney.forEach(entity => entity.removeComponent(GainMoney));

		const removeGainInterest = new Array<Entity>();
		for (const entity of this.queries.interest.results) {
			const player = getEntityPlayer(entity, this.game);
			if (!player) continue;

			const interest = entity.getComponent(GainInterest);
			if (player.currentFunds >= interest.requiredSavings) {
				this.giveMoney(player, interest.amount);
			}

			removeGainInterest.push(entity);
		}
		removeGainInterest.forEach(entity => entity.removeComponent(GainInterest));

		const removeSpendMoney = new Array<Entity>();
		for (const entity of this.queries.spendMoney.results) {
			const player = getEntityPlayer(entity, this.game);
			if (!player) continue;

			const spend = entity.getComponent(SpendMoney);
			this.spendMoney(player, spend.amount);

			removeSpendMoney.push(entity);
		}
		removeSpendMoney.forEach(entity => entity.removeComponent(SpendMoney));
	}

	giveMoney(player: Player, amount: number) {
		player.currentFunds += amount;
		if (this.game.getCurrentState() === 'simulation') {
			player.bonusIncome += amount;
		}
		this.game.onGainMoney(player, amount);
	}

	spendMoney(player: Player, amount: number) {
		console.log(`about to spend ${amount} money=${player.currentFunds} bonus=${player.bonusIncome}`);
		player.currentFunds = Math.max(0, player.currentFunds - amount);
		if (this.game.getCurrentState() === 'simulation') {
			player.bonusIncome = Math.max(0, player.bonusIncome - amount);
		}
		this.game.onGainMoney(player, -amount);
		console.log(`spent ${amount} money=${player.currentFunds} bonus=${player.bonusIncome}`);
	}
}

UnspentMoneySystem.queries = {
	convertToHealth: {
		components: [SetHealthEqualMoney, Health, Ownership], listen: { added: true }
	},
	gainMoney: {
		components: [GainMoney, Ownership]
	},
	spendMoney: {
		components: [SpendMoney, Ownership]
	},
	interest: {
		components: [GainInterest, Ownership]
	},
}